import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import classnames from 'classnames';
import ArticleReadButton from './article-read-button';
import ClearFix from '../clearfix';
import ArticleImage from './article-image';
import ArticleDetails from './article-details';
import ArticleTitle from './article-title';
import ArticleHeader from './article-header';
import { USER_TYPE_REP } from '../../../data/userTypes';

import './style.css';

class Article extends Component {
  setTextColor = (color) => {
    switch (color) {
      case 'red':
        return 'white';
      case 'grey':
        return 'yellow';
      case 'yellow':
        return 'red';
      case 'white':
        return 'grey';
      default:
        return 'white';
    }
  };

  mapColorToNumber = (color) => {
    switch (color) {
      case 0:
        return 'red';
      case 1:
        return 'grey';
      case 2:
        return 'yellow';
      case 3:
        return 'white';
      default:
        return 'black';
    }
  };

  render() {
    const {
      id, image, featured, date, title, color: colorProp, type, category
    } = this.props;
    const { mapColorToNumber, setTextColor } = this;

    const link = `${type === USER_TYPE_REP ? '/team' : ''}/article/${id}`;
    const color = mapColorToNumber(colorProp || 0);
    const textColor = setTextColor(color);

    return (
      <Row>
        <div className="article-item">
          <div className={classnames('overlay', color)}/>
          <div className={classnames('tile-arrow', color)}/>
          <ArticleDetails>
            <ArticleHeader date={date} featured={featured} category={category}/>
            <ClearFix />
            <ArticleTitle
              link={link}
              textColor={textColor}
              title={title}
            />
          </ArticleDetails>
          <ArticleReadButton link={link} textColor={textColor} type={type} category={category}/>
          <ArticleImage id={id} image={image}/>
        </div>
      </Row>
    );
  }
}

Article.propTypes = {
  featured: PropTypes.bool,
  date: PropTypes.string,
  image: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  category: PropTypes.object
};

export default Article;



// WEBPACK FOOTER //
// ./src/components/common/article/index.jsx